// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Y9IN","text":"text__3xR0o","title":"title__yVJan","subTitle":"subTitle__2fJ_j"};


//////////////////
// WEBPACK FOOTER
// ./components/hero/hero.css
// module id = 9dvf
// module chunks = 0